export default __webpack_public_path__ + "static/media/veepee.d5c6da78.svg";